import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Button,
  Grid,
  Icon,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { OCCASIONS } from '../../../utils/lists'

class PlanOccasion extends Component {
  constructor(props) {
    super(props)

    this.state = {
      occasion: props.occasion || null,
    }
  }

  submitRequest = () => {
    this.props.onUpdated({occasion: this.state.occasion})
  }

  render() {
    const { classes, user } = this.props

    return (
      <Fragment>
        <Grid item xs={12} md={8} style={{marginBottom: 10}}>
          {/* <h3 className={classes.h3}>Is there a special occasion ?</h3> */}
          <List className={classes.menu}>
          {OCCASIONS.map((occasion, i) => {
            return <ListItem button key={occasion.value}
                    onClick={() => this.setState({occasion: occasion.value})}
                    classes={{root: (this.state.occasion === occasion.value ? classes.listItemSelected : classes.listItem)}}
                    >
                <ListItemIcon><Icon className={`material-icons-outlined notranslate ${classes.listItemIcon}`}>{occasion.icon}</Icon></ListItemIcon>
                <ListItemText primary={occasion.title} secondary={occasion.description} classes={{primary: classes.listItemText, secondary: classes.listItemTextSecondary}} />
                <ListItemSecondaryAction onClick={() => this.setState({occasion: occasion.value})} classes={{root: classes.listItemTextPrice}}>
                  <Icon className="material-icons-outlined notranslate">{this.state.occasion === occasion.value ? 'radio_button_checked' : 'radio_button_unchecked'}</Icon>
                </ListItemSecondaryAction>
            </ListItem>
          })}
          </List>
        </Grid>

        {/* <Grid item xs={12} md={8}>
          <h3 className={classes.h3}>Do you want help with planning ?</h3>
          <List className={classes.menu}>
          {PROGRAMS.slice(0, 3).map((program, i) => {
            return <ListItem button key={program.value}
                    onClick={() => this.setState({program: program.value})}
                    classes={{root: (this.state.program === program.value ? classes.listItemSelected : classes.listItem)}}
                    >
              <ListItemText
                primary={program.title}
                secondary={program.description}
                classes={{primary: classes.listItemText, secondary: classes.listItemTextSecondary}}
              />
              <ListItemSecondaryAction onClick={() => this.setState({program: program.value})} classes={{root: classes.listItemTextPrice}}>
                {new Intl.NumberFormat([], {style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 0, currency: this.state.currency || 'USD'}).format(Math.round(program.costs))}{program.pricePer ? ' / ' + program.pricePer : ''}
                <Icon className="material-icons-outlined notranslate">{this.state.program === program.value ? 'radio_button_checked' : 'radio_button_unchecked'}</Icon>
              </ListItemSecondaryAction>
            </ListItem>
          })}
          </List>
        </Grid> */}

        <Grid item xs={12} md={8} style={{margin: 'auto'}}>
          <Button disabled={!(this.state.occasion) || this.state.isSubmitting} onClick={this.submitRequest} variant="contained" color="primary" size="large" className={classes.buttonBook}>
            {this.state.isSubmitting ?
              <Fragment>Sending...</Fragment>
              :
              <Fragment>Continue<Icon className="material-icons-outlined notranslate" style={{marginLeft: 10}}>east</Icon></Fragment>
            }
          </Button>
        </Grid>
      </Fragment>
    )
  }
}

const styles = theme => ({
  listItemIcon: {
    color: '#02c39a',
  },
  listItemText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#000',
    maxWidth: '78%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextSecondary: {
    fontSize: 14,
    fontWeight: 600,
    maxWidth: '78%',
    display: 'block',
    overflow: 'hidden',
    // whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextPrice: {
    fontSize: 15,
    fontWeight: 600,
    maxWidth: '70%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    cursor: 'pointer',

    '& .material-icons': {
      color: '#02c39a',
      fontWeight: 300,
      verticalAlign: 'middle',
      margin: '-3px 0px 0px 15px',
    }
  },
  listItemSelected: {
    borderRadius: 15,
    border: '1px solid #02c39a',
    marginBottom: 5,
  },
  listItem: {
    borderRadius: 15,
    border: '1px solid transparent',
    marginBottom: 5,
    backgroundColor: '#fff',

    '&:hover': {
      backgroundColor: '#07c3991a',
    },
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 0px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    padding: 15,
    width: '100%',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
})

export default withRouter(withStyles(styles)(PlanOccasion))
